/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

initSmoothScroll();
initSmoothScroll('.smooth-scroll a');

function initSmoothScroll(elementSelector) {
    elementSelector = (typeof elementSelector !== 'undefined') ? elementSelector : "a.smooth-scroll"; //manually set default parameter values
    try {
        //Listen for clicks on all of the elements that match the selector and have an href
        $(elementSelector + '[href]').click(function (e) {
            //if the current href has no hash, throw an error
            if (!stringInHref(this, '#')) {
                throw "No hash detected in href";
            }
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = $(this.hash),
                        offset = parseInt($(this).data('smooth-scroll-offset'), 10) || 0,
                        delay = parseInt($(this).data('smooth-scroll-delay'), 10) || 0,
                        duration = parseInt($(this).data('smooth-scroll-duration'), 10) || 1000;
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').on('mousewheel', lockScroll)
                            .on('touchmove', lockScroll)
                            .on('keydown', lockScroll);
                    window.setTimeout(function () {
                        $('html,body').animate({
                            scrollTop: target.offset().top - 70 + offset
                        }, duration, function () {
                            $('html,body').off('mousewheel', lockScroll)
                                    .off('touchmove', lockScroll)
                                    .off('keydown', lockScroll);
                        });
                    }, delay);

                    e.preventDefault();
                }
            }
        });
    } catch (err) {
        //console.warn('SmoothScroll did not work: ' + err);
    }

}//end smoothscrollInit fn declaration

function lockScroll(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}

function smoothScrollTo(el, scrollDownLock) {
    var target = $(el);

    if (scrollDownLock && window.pageYOffset < target.offset().top - 90) {
        return;
    }

    if (target.length) {
        $('html,body').animate({
            scrollTop: target.offset().top - 90
        }, 1000);
        return false;
    }
}

/** @function stringInHref
 *   @param {object | jQuery selector string} element - The element (hopefully an anchor)
 *   @param {string} stringToMatch - The string that you are looking to find in the href
 *   @returns { Bool | undefined} - Returns false if it can't find the string in the href, true if it can, otherwise undefined
 *   @description Checks to see if a given string is located in an href.
 */
function stringInHref(element, stringToMatch) {
    try {
        var theHref = jQuery(element).attr('href');
        if (theHref === "") {
            throw "empty";
        }
        if (theHref === undefined) {
            throw "undefined";
        }
        if (theHref === null) {
            throw "null";
        }
        if (theHref.indexOf(stringToMatch) === -1) {
            //console.log('The string ' + stringToMatch + ' is not located in ' + element);
            return false;
        }
        if (theHref.indexOf(stringToMatch) !== -1) {
            //console.log('The string ' + stringToMatch + ' was found at position ' + theHref.indexOf(stringToMatch) + 'in ' + element);
            return true;
        }
    } catch (err) {
        //console.warn('The href error: ' + err);
        return undefined;
    }
}//End fn declaration

export default {
    smoothScrollTo: smoothScrollTo
}

